import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'trending-down-2', 'TrendingDown2', [["path",{"d":"M3 6h5l7 10h6"}],["path",{"d":"M18 19l3 -3l-3 -3"}]]);